module.exports = __webpack_public_path__ + "img/Logo-33.321936b6.svg";